export default __webpack_public_path__ + "static/media/ic-home.d545a8d8.svg";